export const MONETIZATION_RULE_INFOS = ["RULE_1", "RULE_2", "RULE_3", "RULE_4", "RULE_5"] as const;
